module.exports = __webpack_public_path__ + "img/floppy-disk.bc2dd06f.svg";